import React from "react";
function Entrance() {
    return (
        <div className="Entrance">
            <p class="h5 JJ-font">Please use below entrance diagram to avoid being security checked</p>
            <img src="Arangetram_Entrance_Diagram.jpg" class="Img-sizer border border-dark rounded" alt="Arangetram entrance diagram to avoid being security checked"></img>
        </div>
    );
}
export default Entrance;